// extracted by mini-css-extract-plugin
module.exports = {"container":"Mq","productName":"Nq","modal":"Oq","dimensions":"Pq","recipientEmail":"Qq","lowStock":"Rq","recommendedFit":"Sq"};